// extracted by mini-css-extract-plugin
module.exports = {"base":"PhoneEntrance_base__34Hl_","LoginProblem":"PhoneEntrance_LoginProblem__3m2OZ","LoginGuideDesc":"PhoneEntrance_LoginGuideDesc__Let-O"};